import React from 'react';
import Stack from '@mui/material/Stack';
import {Text} from '@tenancy.nz/ui';
import FooterNavFeature from '../navigation/footer-nav-feature';

function FooterFeature() {
  return (
    <Stack
      component="footer"
      mt="auto"
      gap={8}
      sx={{px: {xs: 4, md: 8}, py: 4}}>
      <Stack
        alignItems="center"
        direction={{xs: 'column', sm: 'row-reverse'}}
        flex={1}
        gap={{xs: 2, sm: 4, lg: 8}}
        justifyContent={{sm: 'space-between'}}>
        <FooterNavFeature />
        <Text>Copyright &copy; {new Date().getFullYear()} Tenant.co.nz</Text>
      </Stack>
    </Stack>
  );
}

export default FooterFeature;
